export default function Person({ person }) {
  person = person || {}
  const name = `${person.firstName || 'Unbekannt'} ${person.lastName || person.id}`
  return name
}